module.exports = __webpack_public_path__ + "img/facettedconnections@2x.de98396.jpg";